<!-- <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="needleValue" [centralLabel]="centralLabel"
    [options]="options"></rg-gauge-chart> -->
<app-loader *ngIf="isLoading"></app-loader>
<div class="text-center">
    <rg-gauge-chart [canvasWidth]="canvasWidth" [needleValue]="delimitervalue" [centralLabel]="centralLabel"
        [options]="options"></rg-gauge-chart>

    <div class="d-flex justify-content-center align-items-center my-1" *ngIf="showUrl">
        <div class="fw-bold fs-xl">
            <span [style.color]="statusClr"> {{ securityScore }} </span>
            <span class="gray-clr fs-14">/ {{ securityTotalScore }} </span>
        </div>
        <div class="ms-2">
            <span class="badge badge-pill status-text" [style.color]="statusClr"
                [style.background-color]="statusBg">{{securityScoreStatus}}</span>
        </div>
    </div>
    <div *ngIf="showUrl" class="w-100 d-flex justify-content-center shiftingTextRight">
        <div class="text-sm">
            <!-- <h5 class=" recommend fw-bold">
                {{"DASHBOARD.RECOMMENDATIONS" | translate}} <span *ngIf="securityScore <= 800"
                    class="fw-normal">({{securityRecommendations?.length}})</span></h5> -->
            <h5 class=" recommend fw-bold">
                {{"DASHBOARD.RECOMMENDATIONS" | translate}} <span
                    class="fw-normal">({{securityRecommendations?.length?securityRecommendations?.length:''}})</span>
            </h5>
            <div *ngIf="securityRecommendations?.length != null">
                <div class="my-2 mw-250" [ngClass]="i >= 0 && i <= 3 ? 'd-flex flex-wrap' : 'd-none' "
                    *ngFor="let item of securityRecommendations;let i = index;">
                    <div *ngIf="i < 3" data-toggle="tooltip" class="item-recommend" data-placement="top"
                        title="{{ item.title }}">
                        {{item.title}}
                    </div>
                </div>
            </div>
            <div *ngIf="securityScore == 1000">
                <div class="d-flex">
                    {{"DASHBOARD.PERFECT1000" | translate}}
                </div>
                <div class="d-flex">
                    {{"DASHBOARD.NOACTIONPENDING" | translate}}
                </div>
            </div>
        </div>
    </div>
</div>